import K8ProgramPreferencesSetupView from './container'

export default K8ProgramPreferencesSetupView
